export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12148.9ece4d2e.jpg";